/* tslint:disable */
/* eslint-disable */
/**
 * Happyforce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateCompanyCharacteristicsRequest } from '../models';
// @ts-ignore
import type { GetCharacteristic200Response } from '../models';
// @ts-ignore
import type { SegmentTreeDTO } from '../models';
// @ts-ignore
import type { SegmentTreeHistoryEntryDTO } from '../models';
/**
 * CharacteristicsResourceApi - axios parameter creator
 * @export
 */
export const CharacteristicsResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCompanyCharacteristicsRequest} createCompanyCharacteristicsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyCharacteristics: async (createCompanyCharacteristicsRequest: CreateCompanyCharacteristicsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCompanyCharacteristicsRequest' is not null or undefined
            assertParamExists('createCompanyCharacteristics', 'createCompanyCharacteristicsRequest', createCompanyCharacteristicsRequest)
            const localVarPath = `/api/v1/company/characteristics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyCharacteristicsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} characteristicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyCharacteristics: async (characteristicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'characteristicId' is not null or undefined
            assertParamExists('deleteCompanyCharacteristics', 'characteristicId', characteristicId)
            const localVarPath = `/api/v1/company/characteristics/{characteristicId}`
                .replace(`{${"characteristicId"}}`, encodeURIComponent(String(characteristicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} characteristicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCharacteristic: async (characteristicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'characteristicId' is not null or undefined
            assertParamExists('getCharacteristic', 'characteristicId', characteristicId)
            const localVarPath = `/api/v1/company/characteristics/{characteristicId}`
                .replace(`{${"characteristicId"}}`, encodeURIComponent(String(characteristicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyCharacteristics: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/characteristics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} characteristicId 
         * @param {number} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSegmentTreeHistoryVersion: async (characteristicId: string, version: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'characteristicId' is not null or undefined
            assertParamExists('getSegmentTreeHistoryVersion', 'characteristicId', characteristicId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getSegmentTreeHistoryVersion', 'version', version)
            const localVarPath = `/api/v1/company/characteristics/{characteristicId}/history/{version}`
                .replace(`{${"characteristicId"}}`, encodeURIComponent(String(characteristicId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} characteristicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSegmentTreeHistory: async (characteristicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'characteristicId' is not null or undefined
            assertParamExists('listSegmentTreeHistory', 'characteristicId', characteristicId)
            const localVarPath = `/api/v1/company/characteristics/{characteristicId}/history`
                .replace(`{${"characteristicId"}}`, encodeURIComponent(String(characteristicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} characteristicId 
         * @param {GetCharacteristic200Response} getCharacteristic200Response 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyCharacteristics: async (characteristicId: string, getCharacteristic200Response: GetCharacteristic200Response, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'characteristicId' is not null or undefined
            assertParamExists('updateCompanyCharacteristics', 'characteristicId', characteristicId)
            // verify required parameter 'getCharacteristic200Response' is not null or undefined
            assertParamExists('updateCompanyCharacteristics', 'getCharacteristic200Response', getCharacteristic200Response)
            const localVarPath = `/api/v1/company/characteristics/{characteristicId}`
                .replace(`{${"characteristicId"}}`, encodeURIComponent(String(characteristicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCharacteristic200Response, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CharacteristicsResourceApi - functional programming interface
 * @export
 */
export const CharacteristicsResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CharacteristicsResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateCompanyCharacteristicsRequest} createCompanyCharacteristicsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCompanyCharacteristics(createCompanyCharacteristicsRequest: CreateCompanyCharacteristicsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCharacteristic200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCompanyCharacteristics(createCompanyCharacteristicsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacteristicsResourceApi.createCompanyCharacteristics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} characteristicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCompanyCharacteristics(characteristicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCharacteristic200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCompanyCharacteristics(characteristicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacteristicsResourceApi.deleteCompanyCharacteristics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} characteristicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCharacteristic(characteristicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCharacteristic200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCharacteristic(characteristicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacteristicsResourceApi.getCharacteristic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyCharacteristics(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCharacteristic200Response>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyCharacteristics(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacteristicsResourceApi.getCompanyCharacteristics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} characteristicId 
         * @param {number} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSegmentTreeHistoryVersion(characteristicId: string, version: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SegmentTreeDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSegmentTreeHistoryVersion(characteristicId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacteristicsResourceApi.getSegmentTreeHistoryVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} characteristicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSegmentTreeHistory(characteristicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SegmentTreeHistoryEntryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSegmentTreeHistory(characteristicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacteristicsResourceApi.listSegmentTreeHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} characteristicId 
         * @param {GetCharacteristic200Response} getCharacteristic200Response 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompanyCharacteristics(characteristicId: string, getCharacteristic200Response: GetCharacteristic200Response, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCharacteristic200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompanyCharacteristics(characteristicId, getCharacteristic200Response, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CharacteristicsResourceApi.updateCompanyCharacteristics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CharacteristicsResourceApi - factory interface
 * @export
 */
export const CharacteristicsResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CharacteristicsResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateCompanyCharacteristicsRequest} createCompanyCharacteristicsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyCharacteristics(createCompanyCharacteristicsRequest: CreateCompanyCharacteristicsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCharacteristic200Response> {
            return localVarFp.createCompanyCharacteristics(createCompanyCharacteristicsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} characteristicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyCharacteristics(characteristicId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCharacteristic200Response> {
            return localVarFp.deleteCompanyCharacteristics(characteristicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} characteristicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCharacteristic(characteristicId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCharacteristic200Response> {
            return localVarFp.getCharacteristic(characteristicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyCharacteristics(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCharacteristic200Response>> {
            return localVarFp.getCompanyCharacteristics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} characteristicId 
         * @param {number} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSegmentTreeHistoryVersion(characteristicId: string, version: number, options?: RawAxiosRequestConfig): AxiosPromise<SegmentTreeDTO> {
            return localVarFp.getSegmentTreeHistoryVersion(characteristicId, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} characteristicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSegmentTreeHistory(characteristicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SegmentTreeHistoryEntryDTO>> {
            return localVarFp.listSegmentTreeHistory(characteristicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} characteristicId 
         * @param {GetCharacteristic200Response} getCharacteristic200Response 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyCharacteristics(characteristicId: string, getCharacteristic200Response: GetCharacteristic200Response, options?: RawAxiosRequestConfig): AxiosPromise<GetCharacteristic200Response> {
            return localVarFp.updateCompanyCharacteristics(characteristicId, getCharacteristic200Response, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CharacteristicsResourceApi - object-oriented interface
 * @export
 * @class CharacteristicsResourceApi
 * @extends {BaseAPI}
 */
export class CharacteristicsResourceApi extends BaseAPI {
    /**
     * 
     * @param {CreateCompanyCharacteristicsRequest} createCompanyCharacteristicsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacteristicsResourceApi
     */
    public createCompanyCharacteristics(createCompanyCharacteristicsRequest: CreateCompanyCharacteristicsRequest, options?: RawAxiosRequestConfig) {
        return CharacteristicsResourceApiFp(this.configuration).createCompanyCharacteristics(createCompanyCharacteristicsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} characteristicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacteristicsResourceApi
     */
    public deleteCompanyCharacteristics(characteristicId: string, options?: RawAxiosRequestConfig) {
        return CharacteristicsResourceApiFp(this.configuration).deleteCompanyCharacteristics(characteristicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} characteristicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacteristicsResourceApi
     */
    public getCharacteristic(characteristicId: string, options?: RawAxiosRequestConfig) {
        return CharacteristicsResourceApiFp(this.configuration).getCharacteristic(characteristicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacteristicsResourceApi
     */
    public getCompanyCharacteristics(options?: RawAxiosRequestConfig) {
        return CharacteristicsResourceApiFp(this.configuration).getCompanyCharacteristics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} characteristicId 
     * @param {number} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacteristicsResourceApi
     */
    public getSegmentTreeHistoryVersion(characteristicId: string, version: number, options?: RawAxiosRequestConfig) {
        return CharacteristicsResourceApiFp(this.configuration).getSegmentTreeHistoryVersion(characteristicId, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} characteristicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacteristicsResourceApi
     */
    public listSegmentTreeHistory(characteristicId: string, options?: RawAxiosRequestConfig) {
        return CharacteristicsResourceApiFp(this.configuration).listSegmentTreeHistory(characteristicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} characteristicId 
     * @param {GetCharacteristic200Response} getCharacteristic200Response 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CharacteristicsResourceApi
     */
    public updateCompanyCharacteristics(characteristicId: string, getCharacteristic200Response: GetCharacteristic200Response, options?: RawAxiosRequestConfig) {
        return CharacteristicsResourceApiFp(this.configuration).updateCompanyCharacteristics(characteristicId, getCharacteristic200Response, options).then((request) => request(this.axios, this.basePath));
    }
}

